export function setLanguage(language) {
  return {
    type: "SET_LANGUAGE",
    response: { data: language },
  };
}
